import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(next-frontend)/services/components/KeyOfferings.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/global-components/AtfCta.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/global-components/CTA.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@sanity/next-loader/dist/client-components/live-stream.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@sanity/next-loader/dist/client-components/live.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-sanity/dist/visual-editing/client-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
